import React, { Component } from 'react'
import ConnectIcon from '../../../../../crm/assets/ico-Contact.png'
import { Tooltip } from 'antd'
import intl from 'react-intl-universal'
import './index.less'

class ConnectUs extends Component {
	constructor(props) {
		super(props)
		this.state = {

		}
		this.handleConnectChange = this.handleConnectChange.bind(this)
	}

	handleConnectChange = (val) => {
		this.exposeConnect()
	}

	exposeConnect() {
		var elem = document.getElementById('connect-us')
		if (window.__exposureBuryingPoint) {
			window.__exposureBuryingPoint.init({
				module: elem,
				moduleName: this.props.spmC,
				spm_b: this.props.spmB,
				moduleIndex:  "1",
				event_body: {
					event_code: "",
					event_data: {
						event_entity_info: {
							link_type: 'item'
						}
					}
				}
			});
		}
	}

	render() {
		return (
			<Tooltip placement="rightBottom" arrow={{arrowPointAtCenter:true}} title={
				this.props.isColumbusSeller ? <div className='connet-tooltips'>
					<p className='connet-tooltips-subtitle' style={{ textAlign: 'center', marginTop: '10px' }}>Contact customer service</p>
					<p className='connet-tooltips-title'>Email:</p>
					<p className='connet-tooltips-subtitle'>USseller@dhgate.com</p>
					<p className='connet-tooltips-subtitle'>Mon-Fri 9am to 7pm Beijing Time</p>
					<p className='connet-tooltips-title'>WhatsAPP:</p>
					<p className='connet-tooltips-subtitle'>Key Account Manager</p>
					<a href="https://wa.me/message/O4PXQZW2EL6LA1" target="_blank" style={{ paddingLeft:'12px' }}>Please click here</a>
					<p><img src="//css.dhresource.com/seller/mos/image/chatglb_0223.jpg" alt='' /></p>
				</div> : 
				<div className='connet-tooltips'>
					<p><img src='//www.dhresource.com/dhs/oth/slp/20210827/chat0505.png' /></p>
					<p className='connet-tooltips-subtitle' style={{ textAlign: 'center' }}>{intl.get('seller_connectus_tips')}</p>
				</div>
			}>
				<div className='connect-box' onMouseEnter={this.handleConnectChange} id='connect-us'>
					<img id="connect-img" src={ConnectIcon} alt='' />{intl.get('seller_contact')}
				</div>
			</Tooltip>

		)
	}
}
export default ConnectUs